import { render, staticRenderFns } from "./TermsOfUseDialog.vue?vue&type=template&id=017afe75&scoped=true"
import script from "./TermsOfUseDialog.vue?vue&type=script&lang=js"
export * from "./TermsOfUseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017afe75",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('017afe75')) {
      api.createRecord('017afe75', component.options)
    } else {
      api.reload('017afe75', component.options)
    }
    module.hot.accept("./TermsOfUseDialog.vue?vue&type=template&id=017afe75&scoped=true", function () {
      api.rerender('017afe75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sepay/dialog/TermsOfUseDialog.vue"
export default component.exports